var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.76 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_40);\n      }\n\n      .cls-2 {\n        fill: url(#Naamloos_verloop_37);\n      }\n\n      .cls-3 {\n        fill: url(#Naamloos_verloop_38);\n      }\n\n      .cls-4 {\n        fill: url(#Naamloos_verloop_35);\n      }\n\n      .cls-5 {\n        fill: url(#Naamloos_verloop_32);\n      }\n\n      .cls-6 {\n        fill: url(#Naamloos_verloop_34);\n      }\n\n      .cls-7 {\n        stroke: url(#Naamloos_verloop_118-3);\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        opacity: .85;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-18 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8 {\n        stroke: url(#Naamloos_verloop_118-5);\n      }\n\n      .cls-9 {\n        stroke: url(#Naamloos_verloop_118-4);\n      }\n\n      .cls-10 {\n        stroke: url(#Naamloos_verloop_118-7);\n      }\n\n      .cls-11 {\n        stroke: url(#Naamloos_verloop_118-2);\n      }\n\n      .cls-12 {\n        stroke: url(#Naamloos_verloop_118-6);\n      }\n\n      .cls-13 {\n        stroke: url(#Naamloos_verloop_118-8);\n      }\n\n      .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-20 {\n        opacity: .8;\n      }\n\n      .cls-15 {\n        fill: url(#Naamloos_verloop_13);\n      }\n\n      .cls-16 {\n        fill: url(#Naamloos_verloop_46);\n      }\n\n      .cls-17 {\n        fill: url(#Naamloos_verloop_39);\n      }\n\n      .cls-18 {\n        stroke: url(#Naamloos_verloop_118);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_46",
    "data-name": "Naamloos verloop 46",
    x1: 10.44,
    y1: 20.7,
    x2: 21.63,
    y2: 11.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fb2e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118",
    "data-name": "Naamloos verloop 118",
    x1: 14.32,
    y1: 4.16,
    x2: 15.32,
    y2: 4.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ee7183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f0677c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f3576f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f7415d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fc2545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-2",
    "data-name": "Naamloos verloop 118",
    x1: 4.39,
    y1: 7.99,
    x2: 6.79,
    y2: 7.99,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-3",
    "data-name": "Naamloos verloop 118",
    x1: 0.27,
    y1: 17.23,
    x2: 3.25,
    y2: 17.23,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-4",
    "data-name": "Naamloos verloop 118",
    x1: 4.39,
    y1: 26.47,
    x2: 6.79,
    y2: 26.47,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-5",
    "data-name": "Naamloos verloop 118",
    x1: 14.32,
    y1: 30.29,
    x2: 15.32,
    y2: 30.29,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-6",
    "data-name": "Naamloos verloop 118",
    x1: 22.86,
    y1: 26.47,
    x2: 25.26,
    y2: 26.47,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-7",
    "data-name": "Naamloos verloop 118",
    x1: 26.4,
    y1: 17.23,
    x2: 29.38,
    y2: 17.23,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_118-8",
    "data-name": "Naamloos verloop 118",
    x1: 22.86,
    y1: 7.99,
    x2: 25.26,
    y2: 7.99,
    xlinkHref: "#Naamloos_verloop_118"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39",
    "data-name": "Naamloos verloop 39",
    x1: 27.13,
    y1: 54.92,
    x2: 37.37,
    y2: 54.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_13",
    "data-name": "Naamloos verloop 13",
    x1: 5.78,
    y1: 33.64,
    x2: 58.73,
    y2: 33.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_38",
    "data-name": "Naamloos verloop 38",
    x1: 11.91,
    y1: 32.72,
    x2: 21.76,
    y2: 45.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ef697d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f54d67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fd2142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_37",
    "data-name": "Naamloos verloop 37",
    x1: 13.89,
    y1: 19.87,
    x2: 22.16,
    y2: 30.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ee7284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ef6b7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f15f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f54e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f93856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fe1e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_40",
    "data-name": "Naamloos verloop 40",
    x1: 27.54,
    y1: 20,
    x2: 36.72,
    y2: 30.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ef6e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f25d74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f7435e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fe1d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_34",
    "data-name": "Naamloos verloop 34",
    x1: 26.23,
    y1: 32.97,
    x2: 38.19,
    y2: 45.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ee7082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f06479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f4516a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f93654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_32",
    "data-name": "Naamloos verloop 32",
    x1: 41.19,
    y1: 33.89,
    x2: 54.06,
    y2: 44.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f3586f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f93653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fd2143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_35",
    "data-name": "Naamloos verloop 35",
    x1: 40.95,
    y1: 20.43,
    x2: 50.57,
    y2: 29.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ef6c7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f93553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 14.82,
    cy: 17.23,
    r: 7.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 14.82,
    y1: 5.15,
    x2: 14.82,
    y2: 3.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 6.29,
    y1: 8.69,
    x2: 4.89,
    y2: 7.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2.75,
    y1: 17.23,
    x2: 0.77,
    y2: 17.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 6.29,
    y1: 25.77,
    x2: 4.89,
    y2: 27.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 14.82,
    y1: 29.3,
    x2: 14.82,
    y2: 31.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 23.36,
    y1: 25.77,
    x2: 24.76,
    y2: 27.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 26.9,
    y1: 17.23,
    x2: 28.88,
    y2: 17.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 23.36,
    y1: 8.69,
    x2: 24.76,
    y2: 7.29
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M56.4,46.15c-.1.29-.3.54-.55.7-.21.13-.46.21-.71.21H9.35c-.26,0-.51-.07-.71-.21-.25-.16-.45-.4-.55-.7-.06-.17-.07-.37-.05-.6l3.33-26.08c.09-.74.73-1.3,1.47-1.3h38.8c.75,0,1.38.56,1.47,1.3l3.33,26.08c.03.23.01.43-.05.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.74,50.32h-2.95c-.56,0-1.06.37-1.22.91l-2.44,8.29h10.24l-2.41-8.28c-.16-.54-.65-.91-1.22-.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M54.7,51.38c.21,0,3.99-.11,3.99-5.09.05-.33.05-.67,0-1.03l-3.33-26.08c-.24-1.87-1.84-3.28-3.73-3.28H12.84c-1.89,0-3.49,1.41-3.73,3.28l-3.33,26.08c0,6.13,3.76,6.12,4,6.12h44.92ZM56.4,46.15c-.1.29-.3.54-.55.7-.21.13-.46.21-.71.21H9.35c-.26,0-.51-.07-.71-.21-.25-.16-.45-.4-.55-.7-.06-.17-.07-.37-.05-.6l3.33-26.08c.09-.74.73-1.3,1.47-1.3h38.8c.75,0,1.38.56,1.47,1.3l3.33,26.08c.03.23.01.43-.05.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.52,32.2h-12.02c-.24,0-.44.18-.47.41l-1.56,11.98c-.03.21-.01.4.04.56.1.27.29.5.53.65.2.13.43.2.68.2h12.18c.25,0,.46-.2.47-.45l.63-12.85c.01-.27-.2-.5-.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.16,19.31h-10.13c-.71,0-1.31.52-1.4,1.21l-1.26,9.7c-.04.28.18.53.47.53h11.81c.25,0,.46-.2.47-.45l.51-10.5c.01-.27-.2-.5-.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.04,30.76h12.68c.27,0,.49-.23.47-.5l-.51-10.5c-.01-.25-.22-.45-.47-.45h-11.65c-.25,0-.46.2-.47.45l-.51,10.5c-.01.27.2.5.47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.85,32.2h-12.94c-.25,0-.46.2-.47.45l-.63,12.85c-.01.27.2.5.47.5h14.2c.27,0,.49-.23.47-.5l-.63-12.85c-.01-.25-.22-.45-.47-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.05,44.6l-1.56-11.98c-.03-.24-.23-.41-.47-.41h-11.77c-.27,0-.49.23-.47.5l.63,12.85c.01.25.22.45.47.45h11.93c.24,0,.48-.07.68-.2.24-.15.43-.37.53-.65.06-.15.07-.35.04-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.12,30.76h11.57c.29,0,.51-.25.47-.53l-1.26-9.7c-.09-.69-.69-1.21-1.4-1.21h-9.88c-.27,0-.49.23-.47.5l.51,10.5c.01.25.22.45.47.45Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolar);
export default __webpack_public_path__ + "static/media/icon_solar.c894b118c35a914bae53207b0a42150b.svg";
export { ForwardRef as ReactComponent };